<fui-icon [height]="12" [icon]="'exclamation'" [width]="2"></fui-icon>
@if (control?.errors?.['validationMessages'] || control?.errors?.['required']) {
    <fui-validation-pop [popped]="popped"
                        [parentVerticalAlignment]="verticalAlignment">
        @for (validationMessage of control?.errors?.['validationMessages']; track validationMessage) {
            <div>
                {{ validationMessage?.messageKey | translate: validationMessage?.['messageParams'] }}
            </div>
        }
        @if (control?.errors?.['required']) {
            <div>
                {{ 'validation.common.required' | translate }}
            </div>
        }
    </fui-validation-pop>
}
